module.exports = __webpack_public_path__ + "static/media/call_driver.9da7fc52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/commonImages/call_driver.svg
// module id = 808
// module chunks = 0